<template lang="pug">
div
  //Notification Alert
  Notificationalert(
    v-if="controls.alert.display" 
    v-bind:alert="controls.alert"
  )

  app-icon-btn(
    @click.native="showModal",
    data-kind="link",
    data-icon="fa-solid fa-envelope",
    :data-label="$I18n.t('vue.send_email_invoice_modal.title')"
    :data-title="$I18n.t('vue.send_email_invoice_modal.title')"
  )

  // Modal
  app-modal(
    :showing="controls.modal.showing",
    @showing="controls.modal.showing = $event"
  )
    // Header
    template(#header)
      p {{labels.modal_title}}
    template(#body)
      // Spinner Loading
      div(v-if="state.sending" class="tw-text-center tw-my-20")
        div(class="spinner-border spinner-border-sm" role="status")

      // FORM
      div(v-else)
        //- Campo From (solo lectura)
        .row.mb-3
          .col-12
            .form-group.row
              .tw-text-left
                label.col.col-form-label.text-right.app-label-color From
                .col
                  .tw-flex.tw-items-center.tw-gap-2
                    i.fa-solid.fa-envelope-circle-check.tw-text-green-500
                    span.tw-font-medium.tw-text-gray-700 {{ senderEmail }}
                    span.tw-text-xs.tw-text-gray-400.tw-ml-2 (read-only)
        
        app-form.tw-py-4(v-bind:grid="formGrid")
        
        // Sección de adjuntos
        div(class="tw-mb-4")
          label(class="col col-form-label text-right app-label-color") {{$I18n.t('vue.send_email_invoice_modal.label_attachments')}}
          div(class="tw-border tw-border-gray-300 tw-rounded-md tw-p-4")
            // Botones para agregar archivos
            div(class="tw-flex tw-gap-3 tw-mb-3 tw-justify-between")
              div(class="tw-flex tw-gap-3")
                button(
                  type="button"
                  @click="triggerFileInput"
                  class="tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-text-sm tw-flex tw-items-center"
                )
                  i(class="fa-solid fa-paperclip tw-mr-2")
                  | {{$I18n.t('vue.send_email_invoice_modal.add_local_file')}}
                
                button(
                  type="button"
                  @click="showDropboxPicker"
                  class="tw-bg-green-500 hover:tw-bg-green-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-text-sm tw-flex tw-items-center"
                )
                  i(class="fa-brands fa-dropbox tw-mr-2")
                  | {{$I18n.t('vue.send_email_invoice_modal.add_dropbox_file')}}
              
              // Botón PDF a la derecha
              button(
                type="button" 
                @click="previewPDF"
                class="tw-bg-red-500 hover:tw-bg-red-600 tw-text-white tw-px-3 tw-py-2 tw-rounded tw-text-sm tw-flex tw-items-center"
                title="Preview PDF"
              )
                i.fa-solid.fa-file-pdf
                span.tw-ml-2 Preview PDF
                  
            // Input de archivo oculto
            input(
              ref="fileInput"
              type="file"
              multiple
              @change="handleFileSelect"
              style="display: none"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt,.xlsx,.xls"
            )
            
            // Lista de archivos seleccionados
            div(v-if="attachments.length > 0" class="tw-mt-3")
              h4(class="tw-text-sm tw-font-semibold tw-mb-2") {{$I18n.t('vue.send_email_invoice_modal.selected_files')}}:
              div(
                v-for="(attachment, index) in attachments"
                :key="index"
                class="tw-flex tw-items-center tw-justify-between tw-bg-gray-50 tw-p-2 tw-rounded tw-mb-2"
              )
                div(class="tw-flex tw-items-center")
                  i(:class="getFileIcon(attachment.name)" class="tw-mr-2 tw-text-blue-500")
                  span(class="tw-text-sm") {{ attachment.name }}
                  span(class="tw-text-xs tw-text-gray-500 tw-ml-2") ({{ formatFileSize(attachment.size) }})
                button(
                  type="button"
                  @click="removeAttachment(index)"
                  class="tw-text-red-500 hover:tw-text-red-700 tw-text-sm"
                )
                  i(class="fa-solid fa-times")
        
        label(class="col col-form-label text-right app-label-color") {{$I18n.t('vue.send_email_invoice_modal.label_message')}}
        quill-editor(
          :content="contentHTML"
          :options="editorOption"
          @change="onEditorChange($event)"
        )
    template(#footer)
      .app-buttons-row.justify-end(v-if="!state.sending")
        app-icon-btn(
          data-kind="link",
          @click.native="clear",
          data-icon="fa-solid fa-eraser",
          :data-label="labels.clear_btn"
        )
        app-icon-btn(
          data-kind="link",
          @click.native="cancel",
          data-icon="fa-solid fa-square-xmark",
          :data-label="labels.cancel_btn"
        )
        app-icon-btn(
          data-kind="btn",
          @click.native="send",
          data-icon="fa-solid fa-envelope",
          :data-label="labels.send_btn"
        )

  // PDF Preview Modal
  app-modal(
    :showing="controls.pdfModal.showing",
    @showing="controls.pdfModal.showing = $event"
    size="xl"
  )
    template(slot="header")
      p PDF Preview
    template(slot="body")
      div(style="height: 80vh; width: 100%;")
        iframe(
          v-if="pdfUrl"
          :src="pdfUrl"
          style="width: 100%; height: 100%; border: none;"
          type="application/pdf"
        )
        div(v-else class="tw-flex tw-justify-center tw-items-center tw-h-full")
          p Loading PDF...
    template(slot="footer")
      .app-buttons-row.justify-end
        app-icon-btn(
          data-kind="link",
          @click.native="closePdfModal",
          data-icon="fa-solid fa-xmark",
          data-label="Close"
        )
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

import { ActiveValue } from "../../core/active_support";
import CoreComponents from "../core";
import {BackendService} from '../../services';
const { ActiveValuesMixin, ProcessingMixin } = require("../../mixins");

export default {
  mixins: [ActiveValuesMixin, ProcessingMixin],
  components: {
    quillEditor,
    "app-modal": CoreComponents.Modal,
    "app-icon-btn": CoreComponents.AppIconBtn,
    "app-form": CoreComponents.Detailform,
    "Notificationalert": CoreComponents.Notificationalert,
  },
  props:{
    dataId: Number,
    dataInvoice: Object,
  },
  data: function () {
    return {
      contentHTML:  "",
      attachments: [],
      dropboxPicker: null,
      editorOption: {
        // Some Quill options...
      },
      record: {
        invoice: this.dataInvoice,
      },
      state: {
        sending: false,
      },
      controls: {
        modal: {
          showing: false,
        },
        pdfModal: {
          showing: false,
        },
        alert:{
          display: false,
          type: "",
          notice: "",
          message: "",
          link: {
            text: "",
            href: ""
          }
        },
      },
      pdfUrl: null,
      values: {
        to: ActiveValue().setup((i) => {
          i.setLabel(this.$I18n.t('vue.send_email_invoice_modal.label_to'));
          i.setInputTitle(this.$I18n.t('vue.send_email_invoice_modal.title_to'));
          i.setValue(this.dataInvoice.list_emails_from_billing_notes.join('; '));
          i.setInputKind("text");
          i.required();
        }),
        cc: ActiveValue().setup((i) => {
          i.setLabel(this.$I18n.t('vue.send_email_invoice_modal.label_cc'));
          i.setInputTitle(this.$I18n.t('vue.send_email_invoice_modal.title_cc'));
          i.setValue("");
          i.setInputKind("text");
        }),
        cco: ActiveValue().setup((i) => {
          i.setLabel(this.$I18n.t('vue.send_email_invoice_modal.label_cco'));
          i.setInputTitle(this.$I18n.t('vue.send_email_invoice_modal.title_cco'));
          i.setValue("");
          i.setInputKind("text");
        }),
        subject: ActiveValue().setup((i) => {
          i.setLabel(this.$I18n.t('vue.send_email_invoice_modal.label_subject'));
          i.setInputTitle(this.$I18n.t('vue.send_email_invoice_modal.title_subject'));
          i.setValue("Kanela Invoice: " + this.dataInvoice.list_subsidaries_names.join('; ') + ' - ' + (this.dataInvoice.document_number=='' ? this.dataInvoice.id : this.dataInvoice.document_number) );
          i.setInputKind("text");
          i.required();
        }),
      },
      labels:{
        clear_btn: this.$I18n.t('vue.send_email_invoice_modal.button_clear'),
        cancel_btn: this.$I18n.t('vue.send_email_invoice_modal.button_cancel'),
        send_btn: this.$I18n.t('vue.send_email_invoice_modal.button_create'),
        confirmation_question: this.$I18n.t('vue.send_email_invoice_modal.question'),
        confirmation_reject: this.$I18n.t('vue.send_email_invoice_modal.reject'),
        confirmation_accept: this.$I18n.t('vue.send_email_invoice_modal.accept'),
        modal_title: this.$I18n.t('vue.send_email_invoice_modal.title'),
      }
    };
  },
  computed: {
    formGrid: function () {
      return [
        [this.values.to],
        [this.values.cc,       this.values.cco],
        [this.values.subject],
      ];
    },
    senderEmail: function() {
      // Obtener el email del remitente desde los datos de la factura
      // Si vendor_id == 3 (Commercial Fire, LLC) usa kanela.commercial@gmail.com
      // De lo contrario usa mykanela@gmail.com
      return this.dataInvoice.sender_email || 'mykanela@gmail.com';
    }
  },
  mounted(){
    this.setContentHTML();
  },
  methods: {
    setContentHTML: function(){
      let result = "";
      
      // Validación inteligente de fecha del servicio vs fecha actual
      let serviceDate, currentDate, isServiceInFuture = false;
      
      try {
        // Intentar parsear la fecha del servicio
        // Parse dates like "October 2nd, 2025"
        const dateStr = this.dataInvoice.american_format_date;
        const cleanDateStr = dateStr.replace(/(st|nd|rd|th),/, ','); // Remove ordinal suffixes
        serviceDate = new Date(cleanDateStr);
        currentDate = new Date();
        
        // Verificar si la fecha es válida
        if (!isNaN(serviceDate.getTime())) {
          // Resetear horas para comparar solo fechas
          serviceDate.setHours(0, 0, 0, 0);
          currentDate.setHours(0, 0, 0, 0);
          
          isServiceInFuture = serviceDate > currentDate;
          console.log(isServiceInFuture ? "🟢 Service date is in the future." : "🔴 Service date is not in the future.");
          
          // Log para debugging (solo en development)
          if (process.env.NODE_ENV !== 'production') {
            console.log('📅 Email Text Logic:', {
              serviceDate: serviceDate,
              serviceDateParsed: serviceDate,
              currentDate: currentDate,
              isServiceInFuture: isServiceInFuture
            });
          }
        } else {
          console.warn('⚠️ Invalid service date format:', serviceDate);
        }
      } catch (error) {
        console.error('❌ Error parsing service date:', error);
      }
      
      // Texto dinámico según la fecha del servicio
      let serviceText = ""
      if (isServiceInFuture){
        serviceText = 'services scheduled to be performed on';
      }else{
        serviceText = 'services that were performed on';
      }
      let contentHTML = '<h3><strong>Good evening,</strong></h3>'+
                        '<h3><br></h3>'+
                        '<h3><strong>Please see the attached invoice for ' + serviceText + ' <u>'+this.dataInvoice.american_format_date+'</u>.</strong></h3>'+
                        '<h3><br></h3>'+
                        '<h3><strong>You now have the option to pay via Zelle and with a credit card as stated on the invoice.</strong></h3>'+
                        '<h3><br></h3>'+
                        '<h3><strong><em><u>Please confirm receipt of this email.</u></em></strong></h3>'+
                        '<h3><br></h3>'+
                        '<h3><strong>Thank you for your business!</strong></h3>'+
                        '<p><br></p>'
      
      let contentHTML_COD = '<h3><strong>Good evening,</strong></h3>'+
                            '<h3><br></h3>'+
                            '<h3><strong>Please see the attached invoice for ' + serviceText + ' <u>'+this.dataInvoice.american_format_date+'</u>.</strong></h3>'+
                            '<h3><br></h3>'+
                            '<h4><strong>The payment is due when service is rendered, we\'d very much appreciate it if you can place the check in an envelope and <u>seal it</u>.</strong></h4>'+
                            '<h3><br></h3>'+
                            '<h3><strong>You now have the option to pay via Zelle and with a credit card as stated on the invoice.</strong></h3>'+
                            '<h3><br></h3>'+
                            '<h3><strong><em><u>Please confirm receipt of this email.</u></em></strong></h3>'+
                            '<h3><br></h3>'+
                            '<h3><strong>Thank you for your business!</strong></h3>'+
                            '<p><br></p>'
      
      if (this.record.invoice.cod.toUpperCase()=='COD' || this.record.invoice.cod=='0' || this.record.invoice.cod=='1' || this.record.invoice.cod=='' ){
        this.contentHTML = contentHTML_COD;
      }else{
        this.contentHTML = contentHTML;
      }
    },
    onEditorChange({ quill, html, text }) {
      //console.log('editor change!', quill, html, text)
      this.contentHTML = html
    },
    showModal: function () {
      this.controls.modal.showing = true;
    },
    hideModal: function () {
      this.controls.modal.showing = false;
    },
    clear: function () {
      this.resetActiveValues(this.values);
      this.values.to.setValue(this.dataInvoice.list_emails_from_billing_notes.join('; '))
      this.values.subject.setValue("Kanela Invoice: " + this.dataInvoice.list_subsidaries_names.join('; ') + ' - ' + (this.dataInvoice.document_number=='' ? this.dataInvoice.id : this.dataInvoice.document_number))
      this.setContentHTML();
      this.attachments = [];
    },
    cancel: function () {
      this.hideModal();
      this.clear();
    },
    // Métodos para manejo de archivos
    triggerFileInput: function() {
      this.$refs.fileInput.click();
    },
    handleFileSelect: function(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        this.attachments.push({
          name: file.name,
          size: file.size,
          type: file.type,
          file: file,
          source: 'local'
        });
      });
      // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
      event.target.value = '';
    },
    removeAttachment: function(index) {
      this.attachments.splice(index, 1);
    },
    formatFileSize: function(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    // Método para previsualizar el PDF que se adjuntará
    previewPDF: function() {
      const invoiceId = this.record.invoice.id;
      // Agregar parámetro para prevenir descarga automática
      this.pdfUrl = `/ipdf/${invoiceId}/download_invoice?type=C&preview=1`;
      this.controls.pdfModal.showing = true;
    },
    closePdfModal: function() {
      this.controls.pdfModal.showing = false;
      this.pdfUrl = null;
    },
    getFileIcon: function(filename) {
      const ext = filename.split('.').pop().toLowerCase();
      const iconMap = {
        pdf: 'fa-solid fa-file-pdf',
        doc: 'fa-solid fa-file-word',
        docx: 'fa-solid fa-file-word',
        xls: 'fa-solid fa-file-excel',
        xlsx: 'fa-solid fa-file-excel',
        jpg: 'fa-solid fa-file-image',
        jpeg: 'fa-solid fa-file-image',
        png: 'fa-solid fa-file-image',
        txt: 'fa-solid fa-file-text',
        default: 'fa-solid fa-file'
      };
      return iconMap[ext] || iconMap.default;
    },
    showDropboxPicker: function() {
      if (!window.Dropbox) {
        alert(this.$I18n.t('vue.send_email_invoice_modal.dropbox_not_loaded'));
        return;
      }

      const options = {
        success: (files) => {
          files.forEach(file => {
            this.attachments.push({
              name: file.name,
              size: file.bytes,
              type: file.name.split('.').pop(),
              url: file.link,
              source: 'dropbox'
            });
          });
        },
        cancel: () => {
          // Usuario canceló
        },
        linkType: 'direct',
        multiselect: true,
        extensions: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.txt', '.xlsx', '.xls']
      };

      window.Dropbox.choose(options);
    },
    disabled_inputs: function () {
      
    },
    valid: function () {
      let ins = this.values;
      return Object.values(this.values)
        .map((i) => {
          i.validate();
          return i.hasError();
        })
        .every((e) => e === false);
    },
    stringify: function () {
      let array_invoice_ids = [this.dataId];
      let params = JSON.stringify({
        id: this.record.invoice.id,
        to: this.values.to.input,
        cc: this.values.cc.input,
        cco: this.values.cco.input,
        subject: this.values.subject.input,
        message: this.contentHTML,
        attachments: this.attachments.map(attachment => ({
          name: attachment.name,
          size: attachment.size,
          type: attachment.type || attachment.name.split('.').pop(),
          source: attachment.source,
          url: attachment.url || null
        }))
      });
      return params;
    },
    send: function () {
      let self = this;
      
      // Protección contra clics múltiples
      if (this.state.sending) {
        console.log('Email sending already in progress, ignoring duplicate request');
        return;
      }
      
      if (self.valid()) {
        this.state.sending = true;

        // Si no hay archivos adjuntos, usar el método original
        if (this.attachments.length === 0) {
          BackendService
            .send_email_invoice(self.stringify())
            .then((response) => {
              self.handleEmailResponse(response);
            })
            .catch(() => {
              self.handleEmailError();
            })
            .finally(()=>{
              self.finalizeEmailSend();
            });
        } else {
          // Si hay archivos adjuntos, usar el nuevo método
          const formData = new FormData();
          const emailData = {
            id: this.record.invoice.id,
            to: this.values.to.input,
            cc: this.values.cc.input,
            cco: this.values.cco.input,
            subject: this.values.subject.input,
            message: this.contentHTML,
            dropbox_files: []
          };

          // Agregar archivos locales al FormData
          this.attachments.forEach((attachment, index) => {
            if (attachment.source === 'local') {
              formData.append(`attachments[]`, attachment.file);
            } else if (attachment.source === 'dropbox') {
              emailData.dropbox_files.push({
                name: attachment.name,
                url: attachment.url,
                size: attachment.size
              });
            }
          });

          // Agregar datos del email
          formData.append('email_data', JSON.stringify(emailData));

          BackendService
            .send_email_invoice_with_attachments(formData)
            .then((response) => {
              self.handleEmailResponse(response);
            })
            .catch(() => {
              self.handleEmailError();
            })
            .finally(()=>{
              self.finalizeEmailSend();
            });
        }
      }
    },
    handleEmailResponse: function(response) {
      console.log(response);
      this.controls.alert.notice = 'vue.send_email_invoice_modal.result.'+response.notice
      if (response.isOk) {
        this.controls.alert.type="success"
        this.controls.alert.message = 'vue.empty'
        this.controls.alert.link.text = 'vue.empty'
        this.controls.alert.link.href=""
      }else{
        console.log("response.isError", response)
        this.controls.alert.type="danger"
        this.controls.alert.notice = 'vue.send_email_invoice_modal.result.email_not_sent'
        this.controls.alert.message = response.error_message
        this.controls.alert.link.text = 'vue.send_email_invoice_modal.result.email_not_sent'
        this.controls.alert.link.href=""
      }
      this.state.edit = false;
      this.state.show = true;
      this.state.sending = false;
    },
    handleEmailError: function() {
      this.state.edit = false;
      this.state.show = true;
      this.state.sending = false;
      this.controls.alert.type="danger"
      this.controls.alert.notice = 'vue.send_email_invoice_modal.result.email_not_sent'
      this.controls.alert.message = ""
      this.controls.alert.link.text = 'vue.empty'
      this.controls.alert.link.href=""
    },
    finalizeEmailSend: function() {
      this.cancel();
      this.state.sending=false;
      this.controls.alert.display=true
    },
  },
};
</script>
